(() => {
  const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const initialiseScope = (scope) => {
    if (!scope || scope.dataset.tesMenuInitialised === 'true') return;

    const drawer = scope.querySelector('[data-tes-menu-drawer]');
    const openButtons = scope.querySelectorAll('[data-tes-menu-open]');
    const closeButtons = scope.querySelectorAll('[data-tes-menu-close]');
    if (!drawer || !openButtons.length) return;

    scope.dataset.tesMenuInitialised = 'true';
    let activeTrigger = null;

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('tes-menu-open');
      if (activeTrigger) activeTrigger.focus();
      activeTrigger = null;
    };

    const openDrawer = (trigger) => {
      activeTrigger = trigger;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openButtons.forEach((button) => button.setAttribute('aria-expanded', button === trigger ? 'true' : 'false'));
      document.body.classList.add('tes-menu-open');
      drawer.querySelector('.tes-menu-drawer__close')?.focus();
    };

    openButtons.forEach((button) => button.addEventListener('click', () => openDrawer(button)));
    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
    drawer.querySelectorAll('a[href]').forEach((link) => link.addEventListener('click', closeDrawer));

    scope.addEventListener('keydown', (event) => {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = [...drawer.querySelectorAll(focusableSelector)].filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  const initialiseAll = (root = document) => root.querySelectorAll('[data-tes-menu-scope]').forEach(initialiseScope);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
